import { useCallback, useState } from 'react'
import z from 'zod'
import { V2L3GenerateMeetingLinksModal, V2L3GenerateMeetingLinksModalPropsLinks } from '@fusion-advantage/formrender'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { AppModal, dismissAppModal } from '../../../redux/appSlice'
import { apiDashboardGenerateVirtualJoinUrls } from '../../../redux/apithunk/apiDashboard'

const checkGuid = (guid: string): boolean => {
	const rParse = z.uuid().safeParse(guid)
	if(!rParse.success) {
		alert('Invalid Member GUID, please try again.')
		return false
	}
	return true
}

export const LxGenerateMeetingLinksModal = () => {
	const loading = useAppSelector(state => Boolean(state.app.ldng.apiDashboardGenerateUrls))
	const [links, setLinks] = useState<V2L3GenerateMeetingLinksModalPropsLinks|null>(null)
	const dispatch = useAppDispatch()
	const [memberGuid, setMemberGuid] = useState<string>('')
	const handleSubmitClick = useCallback(async () => {
		if(!checkGuid(memberGuid)) {
			return
		}
		const r = await dispatch(apiDashboardGenerateVirtualJoinUrls({
			memberGuid: memberGuid,
		}))
		// if error, message will have already displayed
		if(r.isOk()) {
			setLinks(r.value)
		}
	}, [memberGuid, dispatch])
	return (
		<V2L3GenerateMeetingLinksModal
			loading={loading}
			links={links}
			value={memberGuid}
			onChange={(e) => setMemberGuid(e.target.value)}
			onSubmit={handleSubmitClick}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.GenerateMeetingLinks))}
		/>
	)
}
